<template>
    <others>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table
                :searchable="true"
                :fields="fields"
                :items="markings"
                :action="{'text':'Add University Marking','url':route('others.university-marking.create')}"
                :searchlink="route('others.university-marking.search')"
                :canView="isAdmin()"
                :canCreate="isAdmin()"
            >
                <template #course="data">
                    {{ data.item.course.title }}
                </template>
                <template #course_year="data">
                    {{ data.item.course_year.title }}
                </template>
                <template #semester="data">
                    {{ data.item.semester.title }}
                </template>
                <template #max_marks="data">
                    Internal {{ data.item.internal_max_marks }} / External {{ data.item.external_max_marks }}
                </template>
                <template #branch_progress="data">
                    {{ data.item.submitted_branches_count }} / {{ data.item.total_branches_count }}
                </template>
                <template #status="data">
                    {{ data.item.status ? 'Active' : 'Inactive' }}
                </template>
                <template #action="data">
                    <button-link :href="route('others.university-marking.marks', data.item.id)" :class="'mr-2'">
                        Marks
                    </button-link>
                    <button-link :href="route('others.university-marking.edit', data.item.id)">
                        Edit
                    </button-link>
                </template>
            </breeze-table>
        </div>
    </others>
</template>

<script>
import Others from '@/Pages/Others/Others'
import ButtonLink from '@/Components/ButtonLink'
import BreezeTable from '@/Components/Table'

export default {
    components: {
        Others,
        ButtonLink,
        BreezeTable,
    },
    props: ['markings'],
    data() {
        return {
            fields: [
                {'key': 'course', 'label': 'Course'},
                {'key': 'course_year', 'label': 'Course Year'},
                {'key': 'semester', 'label': 'Semester'},
                {'key': 'subjects_count', 'label': 'Subjects'},
                {'key': 'max_marks', 'label': 'Max Marks'},
                {'key': 'branch_progress', 'label': 'Submitted Branches'},
                {'key': 'status', 'label': 'Status'},
                {'key': 'action', 'label': 'Action'},
            ],
        }
    },
    methods: {
        isAdmin() {
            const role = this.$page.props.auth.user.role;

            return role?.type === 'super' || role?.name === 'Super Admin';
        },
    },
}
</script>
